<template>
    <div align="center" id="404">
      <div class="d-inline-block mr-auto">
        <h2>{{ $t('dashboard.nope.title') }}</h2>
        <spacer color="pink" :size="25"></spacer>
      </div>

      <p class="mt-5" v-html="$t('dashboard.nope.intro')"></p>

      <img width="200"
           src="~@/assets/404.svg"
           class="d-block mt-5" />

      <b-btn v-if="!_.isEmpty(user)"
             :to="{ name: 'mini.challenges' }"
             variant="primary"
             class="mt-5">
        <i class="material-icons">
          keyboard_arrow_right
        </i>
        {{ $t('dashboard.nope.button.challenges') }}
      </b-btn>
      <b-btn v-else
             :to="{ name: 'login' }"
             variant="primary"
             class="mt-5">
        <i class="material-icons">
          keyboard_arrow_right
        </i>
        {{ $t('dashboard.nope.button.login') }}
      </b-btn>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  }
}
</script>

<style lang="scss" scoped>
  #404 {
    padding: 2rem;
    background: white;
  }
  .btn {
    padding-right: 1.2rem;

    i {
      margin-top: -0.2rem;
      vertical-align: middle;
    }
  }
</style>
